module.exports = __webpack_public_path__ + "img/maarten-spruyt1.9ffd8d0a.jpg";